'use client';

import { IconRightChevron } from "@/public/assets/icons/IconRightChevron";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import styled from './SearchExpand.module.scss';
import { useEffect, useMemo, useState, useTransition } from "react";
import { usePathname, useRouter } from "next/navigation";
import { IconSearchSideBar } from "@/public/assets/icons/IconSearchSideBar";
import { IconAdd } from "@/public/assets/icons/IconAdd";
import { useSearchExpand } from "./hooks/useSearchExpand";
import { AddNewSessionModal } from "@/features/SearchControl/ui/AddNewSessionModal";
import { alertHandler } from "@/shared/utils/alertHandler";
import { searchStore } from "@/shared/store/searchStore/searchStore";
import { SearchBlock } from "./components/SearchBlock";
import { authStore } from "@/shared/store/authStore/authStore";
import { wsSearch } from "@/shared/service/wsSearch/wsSearch";




export function SearchExpand() {
  const [isPending, startTransition] = useTransition();
  const router = useRouter();
  const fullPathname = usePathname();
  const pathname = '/search';
  const title =  'Сессии';
  const isAdmin = useMemo(() => authStore.state.userInfo && authStore.state.userInfo.roleId === 1, [authStore.state.userInfo]);
  const { 
    modal, 
    activeSessions, 
    sessionId,     
    getActiveSessions,
  } = useSearchExpand();

  async function handleSetPathname(id: number) {
    startTransition(() => { 
      router.push(`${pathname}?id=${id}`);
      searchStore.sync.setNeedUpdate(null);
      // searchStore.sync.setClearAllMNN();
      searchStore.sync.setActiveSession(Number(id));
      searchStore.sync.setSearchMNN([]);
      searchStore.sync.setErrorSearch(false);
      alertHandler.addAlert({ status: 'info', defaultText: `Вы переключились на сессию «${activeSessions.find((item) => item.id === id)?.name || ''}»` });
    });
  }
  
  const [idDisabledWS, setIdDisabledWS] = useState(wsSearch.isConnected());
  
  useEffect(() => {
    const unsubscribe = wsSearch.subscribe((connected) => {
      setIdDisabledWS(connected);
    });
    return () => unsubscribe();
  }, []);

  
  return (
    <>
      <Accordion className={styled.accordion}>
        <AccordionSummary
          className={styled.accordion_summary}
          sx={{
            minHeight: '30px',
            height: '30px',
            '&.Mui-expanded':{
              minHeight: '30px',
              height: '30px',
              marginBottom: '10px !important'
            },
            '&.MuiAccordionSummary-content':{
              margin: '0 !important'
            }
          }}
          expandIcon={<div style={{ transform: "rotate(-90deg)" }}><IconRightChevron width={"15px"} height={"15px"}/></div>}
        
        >
          <div className={styled.accordion_summary_box}>
            <IconSearchSideBar width={'18px'} height={'18px'}/> 
            <div className={styled.accordion_title} style={{ color: fullPathname.includes(pathname) ? 'var(--sapphire-20)' : 'var(--steel-10)' }}>
              {title}
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails className={styled.accordion_body}>
          <div className={styled.accordion_body_addContainer}>
            {isAdmin && (
              <button className={styled.accordion_body_container_add_button} style={{ borderBottomLeftRadius: activeSessions.length > 0 ? '0px' : '8px', borderBottomRightRadius: activeSessions.length > 0 ? '0px' : '8px' }} 
                onClick={modal.onOpenModal} disabled={idDisabledWS}>
                <div className={styled.accordion_body_container_add} 

                >
                  <IconAdd width={20} height={20}/>
                </div>
                Новая сессия
              </button>
            )}
          </div>
          {activeSessions.map((item, index) =>
            <SearchBlock 
              id={item.id} 
              name={item.name} 
              mnn={item.combination_mnn}
              isFirst={index === 0 && authStore.state.userInfo && authStore.state.userInfo.roleId !== 1 || false}
              isLast={index === activeSessions.length - 1} 
              handleSetPathname={handleSetPathname} 
              getActiveSessions={getActiveSessions}
              key={index} 
              isActive={item.id === Number(sessionId)}/>
          )}
        </AccordionDetails>
      </Accordion>
      <AddNewSessionModal onCloseModal={modal.onCloseModal} openModal={modal.openModal} getActiveSessions={getActiveSessions}/>
    </>
  );
}
